<template lang="">
    <div>
        
        <b-row class="p-3">
            <b-col>
                <b-button pill variant="outline-secondary" @click="onOpenNews_addnew">
                    <b-icon icon="newspaper"></b-icon> ເພີ່ມຂ່າວ</b-button>
            </b-col>
        </b-row>
    
        <div class="p-3">
            <b-card  no-body class="overflow-hidden m-3"   v-for="(item,index) in items" :key="index">
                <b-row no-gutters>
                    <b-col>
                        <b-card-body style="white-space: pre;" :title="item.header">
                            <b-card-text style="white-space: pre;">
                              <div>
                                 {{item.content}}
                              </div>
                              <b-link target="_blank" :href="item.attach"> <b-icon icon="file-earmark-pdf-fill"></b-icon> Download File</b-link>
                              <div>
                                <b-badge variant="primary">{{item.create_by}}</b-badge>
                                <b-badge variant="info" class="ml-3">{{item.create_date | formatdate}}</b-badge>
                              </div>
                            </b-card-text>
                        </b-card-body>
                    </b-col>
                </b-row>
            </b-card>
            <infinite-loading @infinite="infiniteHandler" spinner="spiral">
                <div slot="spinner">Loading...</div>
                <div slot="no-more">No more data</div>
                <div slot="no-results">No results data</div>
            </infinite-loading>
        </div>
    
    
    </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment'
export default {
    components: {
        InfiniteLoading,
    },
    data() {
        return {
            page: 0,
            field: '',
            find: '',

            pkey: "",
            table: "",
            fields: [],
            items: [],

            findfied: [],
            user: []
        }
    },
    created() {
        this.user = JSON.parse(localStorage.getItem("Login"));

    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        onOpenNews_addnew() {
            this.$router.push("/news?desc=ແຈ້ງຂ່າວ")
        },
        infiniteHandler($state) {
            this.busy = true;
            setTimeout(() => {

                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/FeedNews" +
                        "?offset=" + this.page + "&fld=" + this.field + "&find=" + this.find, {
                            headers: {
                                'Authorization': 'Bearer ' + this.user.login_hash
                            }
                        }
                    )
                    .then((response) => {
                        //this.pkey=response.data.pkey
                        if (this.page == 0) {
                            // this.fields = JSON.parse(response.data.fields)

                            // this.fields.forEach((item) => {
                            //     this.findfied.push({
                            //         value: item.key,
                            //         text: item.label
                            //     })
                            // })
                            this.items = response.data.items;
                            this.page++;
                            $state.loaded();
                        } else {

                            if (response.data.items.length != 0) {
                                this.page++;
                                this.items = this.items.concat(response.data.items);
                                $state.loaded();
                            } else {
                                $state.complete();
                            }
                            $state.loaded();
                        }
                    });

                this.busy = false;
            }, 200);
        },


    },
    filters:{
        formatdate(value){
         if (value) {
            return moment(String(value)).format('MM/DD/YYYY hh:mm')
          }
      },
    }


}
</script>

<style lang="">

</style>